// frontend/src/pages/admin/transactions.jsx
import React, { useState, useEffect } from 'react';
import { getTransactions } from 'api';
import { formatDate } from '../../utils';

const TransactionsAdminPage = () => {
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchTransactions = async () => {
      setLoading(true);
      try {
        const result = await getTransactions();
        if (result.success) {
          // The data is nested in result.data.data
          setTransactions(result.data.data || []);
        } else {
          setError(result.message);
        }
      } catch (err) {
        setError('Failed to load transactions.');
      } finally {
        setLoading(false);
      }
    };
    fetchTransactions();
  }, []);

  return (
    <div className="p-4 sm:p-6">
      <h1 className="text-xl sm:text-2xl font-semibold text-gray-800 mb-4">Transaction History</h1>
      {error && <div className="error-alert">{error}</div>}
      {loading ? (
        <div className="text-center text-sm sm:text-base">Loading...</div>
      ) : transactions.length === 0 ? (
        <div className="text-center p-4 text-sm sm:text-base">No transactions found.</div>
      ) : (
        <table className="w-full text-sm sm:text-base">
          <thead>
            <tr className="bg-gray-100">
              <th className="p-2 sm:p-3 text-left">Agent Email</th>
              <th className="p-2 sm:p-3 text-left">Lead ID</th>
              <th className="p-2 sm:p-3 text-left">Amount</th>
              <th className="p-2 sm:p-3 text-left">Date</th>
            </tr>
          </thead>
          <tbody>
            {transactions.map(transaction => (
              <tr key={transaction.id} className="border-b">
                <td className="p-2 sm:p-3">{transaction.agent_email}</td>
                <td className="p-2 sm:p-3">{transaction.lead_id}</td>
                <td className="p-2 sm:p-3">${transaction.amount.toFixed(2)}</td>
                <td className="p-2 sm:p-3">{formatDate(transaction.created_at)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default TransactionsAdminPage;